import { createRouter, createWebHashHistory } from 'vue-router';

const routes = [
  {
    name: 'notFound',
    path: '/:path(.*)+',
    redirect: {
      name: 'goods',
    },
  },
  {
    name: 'login',
    path: '/login',
    component: () => import('./view/login'),
    meta: {
      title: '登陆',
    },
  },
  {
    name: '',
    path: '/',
    component: () => import('./view/index'),
    meta: {
      title: '首页',
    },
  },
  {
    name: 'index',
    path: '/index',
    component: () => import('./view/index'),
    meta: {
      title: '首页',
    },
  },
  {
    name: 'news',
    path: '/news',
    component: () => import('./view/news'),
    meta: {
      title: '新闻',
    },
  },
  {
    name: 'my',
    path: '/my',
    component: () => import('./view/my'),
    meta: {
      title: '我的',
    },
  },
  {
    name: 'web',
    path: '/web',
    component: () => import('./view/web'),
    meta: {
      title: '查询',
    },
  }
];

const router = createRouter({
  routes,
  history: createWebHashHistory(),
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export { router };
